import { useQuery } from "@tanstack/react-query";
import { agencySaleDetail } from "../../services/agencies-sales-details";
import { AGENCIES_SALES_DETAILS_QUERY_KEY, SalesHistoryFilters } from "./use-get-agencies-sales-details";

// Totals of the WHOLE filtered history, computed on the server (the list is
// paginated). The key starts with the list key, so a sale or a reversal — which
// invalidate the list — refresh the totals too.
export const useGetAgenciesSalesSummary = (filters: SalesHistoryFilters = {}) => {
  const { data, isLoading, isFetching } = useQuery({
    queryKey: [AGENCIES_SALES_DETAILS_QUERY_KEY, "summary", filters],
    queryFn: () => agencySaleDetail.getSummary(filters),
  });

  return {
    summary: data?.status === "success" ? data.data : null,
    isLoading: isLoading || isFetching,
  };
};
